<template>
    <section id="content">
        <loader v-if="loader == true"></loader>
        <div class="page page-hz-menu-layout">
            <div class="row">
                <div class="col-md-12">
                    <section class="tile">
                        <div class="tile-header dvd dvd-btm">
                            <h1 class="custom-font"><strong>Nova</strong> Simulação de Crédito</h1>
                            <ul class="controls">
                            </ul>
                        </div>
                        <div class="tile-body">
                            <form-propostas></form-propostas>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import HeaderPropostas from './_header.vue';
    import FormPropostas from './_form.vue';

    export default{
        name: 'nova-propostas',
        data() {
            return{
                loader: false
            }
        },
        components: {
            'header-propostas': HeaderPropostas,
            'form-propostas': FormPropostas
        },
        methods:{
//            save: function () {
//                this.loader = true;
//                var $this = this;
//                setTimeout(function () {
//                    $this.loader = false;
//                }, 1000)
//            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/propostas/Nova.vue